// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7400291d","542":"700826f8","732":"ee9f685f","766":"1a0903bb","977":"a185142d"}[chunkId] + ".chunk.js";
};